import React,{Component} from 'react';
import {withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import Dialog from '@react/react-spectrum/Dialog';
import RejectReasons from './RejectReasons';

export class CustomRejectDialog extends Component{
    render(){
        return(
            <div data-am-id="rejectModal">
                <Dialog
                    role='dialog'
                    onClose={this.close}
                    title={i18n.t(this.props.workFlowType+'.rejectBtn.rejectTitle')}
                    confirmLabel={i18n.t(this.props.workFlowType+'.okBtnLabel')}
                    cancelLabel={i18n.t(this.props.workFlowType+'.cancelBtnLabel')}
                    onConfirm={this.props.confirm}
                    onCancel={this.cancel}
                    {...this.props}>
                    <div>
                        <p>{i18n.t(this.props.workFlowType+'.rejectBtn.rejectDesc')}</p>
                        <RejectReasons rejectReasons={this.props.rejectReasons} setSelectedReason={this.props.setSelectedReason}/>
                    </div>
                </Dialog>
            </div>
        )
    }
}


export default withTranslation()(CustomRejectDialog);
